import { Label } from '@primer/react';
import { StarIcon, CopilotIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import { PricingOptions, HeadingTags } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  StarIcon,
  CopilotIcon,
  PropTableValues,
  PricingOptions,
  HeadingTags,
  React
};